import React from 'react';
import GreenLeafApi from '../utils/GreenLeafApi';
import './TeamPage.css';
import {withRouter} from 'react-router-dom';
import {Button, Form, FormGroup, PanelGroup} from 'react-bootstrap';
import AssessmentSection from './AssessmentSection';
import './AssessmentPage.css';
import NotFoundPage from '../NotFoundPage';
import PropTypes from 'prop-types';
import ErrorComponent from '../ErrorComponent';
import _ from 'lodash';

class AssessmentPage extends React.Component {

  constructor(props) {
    super(props);

    this.timer = null;

    this.state = {
      error: null,
      loading: true,
      assessment: {
        name: '',
        subsections: []
      },
      notFound: false,
      currentComment: null
    };
  }

  async componentDidMount() {
    try {
      let assessment;
      if (this.props.assessment) {
        assessment = this.props.assessment;
        this.setState({assessment: this.organizeAssessment(assessment), loading: false});
      } else {

        if (this.props.teamAssessment) {
          assessment = await GreenLeafApi.Assessment.getSubs({team_assessment_id: this.props.teamAssessment.id});
        } else if (this.props.groupAssessmentId) {
          assessment = await GreenLeafApi.Assessment.getSubs({group_team_assessment_id: this.props.groupAssessmentId});
        } else {
          assessment = await GreenLeafApi.Assessment.get(this.props.assessmentId);
        }

        if (assessment.data.length === 0) {
          this.setState({ notFound: true, loading: false });
          return;
        }
        this.setState({assessment: this.organizeAssessment(assessment.data.assessment), loading: false});
      }
    } catch (e) {
      this.setState({ error: e.errors });
    }
  }

  validateState = () => {
    let questionAmount = 0;
    for (let i = 0; i < this.state.assessment.subsections.length; i++) {
      questionAmount += this.state.assessment.subsections[i].questions.length;
    }

    const isComplete = Object.keys(this.props.answers).length === questionAmount;
    if (!isComplete) {
      this.setState({ error: [{msg: 'Please complete the survey in order to submit.'}] });
    }
    return isComplete;
  };

  organizeAssessment = (assessment) => {

    let subsections = _.groupBy(assessment, 'subsection_id');

    let newAssessment = {
      name: assessment[0].assessment_name,
      subsections: []
    };


    Object.values(subsections).forEach(s => {
      let subsection = {
        name: s[0].subsection_name,
        questions: Object.values(_.groupBy(s, 'question_id'))
      };

      newAssessment.subsections.push(subsection);
    });

    return newAssessment;
  };

  onSubmit = (event) => {
    event.preventDefault();

    if(this.validateState()) {
      this.props.onSubmit(event);
    }
  };

  componentWillUnmount() {
    clearTimeout(this.timer);
    if (this.state.currentComment) {
      const target = this.state.currentComment;
      this.props.onUnmount(target);
    }
  }

  onOptionSelect = (question_id, answer_id) => {
    if (this.props.onChange) {
      this.props.onChange(question_id, { answer: answer_id, comment: (this.props.answers[question_id] || {}).comment || null});
    }
    if (this.props.onOptionSelect) {
      this.props.onOptionSelect(question_id, answer_id);
    }
  };

  render() {
    if (this.state.loading) return <p>Loading...</p>;
    if (this.state.notFound) return <NotFoundPage/>;

    let subsections = this.state.assessment.subsections.map((s, i) => {
      return (
        <AssessmentSection
          averageScores={this.props.averageScores}
          key={s.name}
          subsection={s}
          answers={this.props.answers}
          disabled={this.props.disabled}
          onQuestionSelect={this.onOptionSelect}
          handleComment={this.props.onChangeComment}
          subScore={this.props.subScores ? this.props.subScores[i].score : null}/>
      );
    });

    const error = <div data-cy="assess-error"><ErrorComponent error={this.state.error}/></div>;

    return (
      <div>
          <h2 data-cy="assess-header" align="center">
            {this.state.assessment.name}
          </h2>
        {error}
        {this.state.assessment.subsections.length > 0 &&
        <Form onSubmit={this.onSubmit}>
          <PanelGroup
            accordion
            data-cy="assess-group"
            defaultActiveKey={this.state.assessment.subsections[0].name}
            id="assessment-sections"
          >
            {subsections}
          </PanelGroup>
          {!this.props.disabled &&

              <FormGroup>
                <Button
                  data-cy="save-assessment"
                  className='primary pull-right pr1'
                  type="submit"
                  onClick={() => window.scrollTo(0, 0)}
                >
                  Submit
                </Button>
              </FormGroup>

          }
        </Form>
        }
      </div>
    );
  }
}

AssessmentPage.defaultProps = {
  assessmentId: 1,
  disabled: false,
  answers: {},
};

AssessmentPage.propTypes = {
  team: PropTypes.object,
  answers: PropTypes.object,
  disabled: PropTypes.bool,
  onOptionSelect: PropTypes.func,
  onChangeComment: PropTypes.func,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  onUnmount: PropTypes.func,
  assessmentId: PropTypes.number,
  averageScores: PropTypes.bool
};

export default withRouter(AssessmentPage);



// WEBPACK FOOTER //
// ./src/components/teams/AssessmentPage.js